import React, { useState, useEffect, useCallback } from 'react'
import { CustomFields } from './CustomFields'
const { Checkbox, Button } = require('monday-ui-react-core')

interface ChildItemsProps {
  isEditable: boolean
  boardId: string | null
  mappingChildItems: any[]
  boardColumns: DropDownOption[]
  onSetMapping: Function
  setUnfilledRequiredChild: React.Dispatch<React.SetStateAction<string[]>>
}

export const ChildItems: React.FC<ChildItemsProps> = ({ isEditable, boardId, mappingChildItems, onSetMapping, boardColumns, setUnfilledRequiredChild }) => {
  const [childItemIdx, setChildItemIdx] = useState<number | undefined>(undefined)
  const [childItems, setChildItems] = useState<any[]>([])

  const onChooseChildItem = (idx: number): void => {
    // if(mappingChildItems[idx].mandatory === 1) return
    mappingChildItems[idx].isChecked = !mappingChildItems[idx].isChecked
    onSetMapping('childItems', mappingChildItems)
  }

  const onOpenCustomFields = (idx: number | undefined): void => {
    setChildItemIdx(idx)
  }

  const onSetChildItem = (customFields: any): void => {
    mappingChildItems[childItemIdx!].customFields = customFields
    setChildItems(JSON.parse(JSON.stringify(mappingChildItems)))
    onSetMapping('childItems', mappingChildItems)
  }

  /**
   * This useEffect is copying the mappingChildItems to a new state ONLY for tracking the unfilled mendatory fields.
   */
  useEffect(() => {
    setChildItems(mappingChildItems)

    return () => setUnfilledRequiredChild([])
  }, [mappingChildItems])

  const getUnfilledRequiredChild = useCallback(
    (childItems: any[]) => {
      const mappedUnfilledChild = childItems.filter((childItem) => childItem.isChecked && childItem.customFields.some((customField: CustomField) => customField.isRequired && !customField.value)).map((childItem) => childItem.name)
      setUnfilledRequiredChild(mappedUnfilledChild)
    },
    [setUnfilledRequiredChild]
  )

  useEffect(() => {
    getUnfilledRequiredChild(childItems)
  }, [childItems, getUnfilledRequiredChild])

  return (
    <div className="dropdown-container">
      <h2>Additional Items</h2>
      {mappingChildItems.map((childItem: any, idx: number) => (
        <React.Fragment key={childItem.id}>
          <label className="checkbox-container">
            <Checkbox disabled={childItem.mandatory === 1 || !isEditable} checked={childItem.isChecked} onChange={() => onChooseChildItem(idx)} />
            <p>
              {childItem.name} <span>{childItem.mandatory === 1 && '*'}</span>
            </p>
            {childItem.customFields.length ? (
              <Button disabled={!isEditable || !childItem.isChecked} onClick={() => onOpenCustomFields(childItemIdx !== idx ? idx : undefined)}>
                {childItemIdx !== idx ? 'Edit' : 'Close'}
              </Button>
            ) : null}
          </label>
          {idx === childItemIdx && (
            <div className="customfields-childitems-dropdown">
              {childItemIdx !== undefined && <CustomFields isEditable={isEditable} boardId={boardId} mappingCustomFields={mappingChildItems[childItemIdx].customFields} boardColumns={boardColumns} onSetChildItem={onSetChildItem} childName={childItem.name} />}
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  )
}
